import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import Footer from "components/footers/FiveColumnWithInputForm.js";
import Light from './headers/light';
import AnimationRevealPage from 'helpers/AnimationRevealPage';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Swal from 'sweetalert2';
import LightBuyer from './headers/lightBuyer';
import ScrollToTop from './ScrollToTop';

const ProductDetails = () => {
    const { id } = useParams();
    const [product, setProduct] = useState(null);
    const [relatedProducts, setRelatedProducts] = useState([]);
    const [quantity, setQuantity] = useState(1);
    const navigate = useNavigate();
    const [role, setRole] = useState('');
    const [isActive, setIsActive] = useState(true); // State to control button activity

    useEffect(() => {
        const userRole = localStorage.getItem('role');
        setRole(userRole);

        // Check if there is an admin role to decide button state
        const supplierRole = localStorage.getItem('role'); // Example check for admin presence
        if (supplierRole !== "supplier") {
            setIsActive(false); // Disable buttons if no admin
        }

        const fetchProductDetails = async () => {
            try {
                const response = await fetch(`https://hbmdijital.online/api/products/${id}`);
                if (!response.ok) throw new Error("Product not found");
                const data = await response.json();
                setProduct(data);
            } catch (error) {
                console.error("Error fetching product details:", error);
            }
        };
        fetchProductDetails();
    }, [id]);

    useEffect(() => {
        const fetchRelatedProducts = async () => {
            try {
                const response = await fetch(`https://hbmdijital.online/api/same-category-products/${id}`);
                if (!response.ok) throw new Error("Related products not found");
                const data = await response.json();
                setRelatedProducts(data.products);
            } catch (error) {
                console.error("Error fetching related products:", error);
            }
        };
        fetchRelatedProducts();
    }, [id]);

    const handleAddToCart = () => {
        if (product.StockQuantity <= 0) {
            Swal.fire({
                title: 'Stock épuisé!',
                text: `Le produit ${product.Name} est actuellement en rupture de stock.`,
                icon: 'error',
                confirmButtonText: 'OK'
            });
            return;
        }

        if (quantity > product.StockQuantity) {
            Swal.fire({
                title: 'Quantité insuffisante!',
                text: `Il ne reste que ${product.StockQuantity} unités en stock.`,
                icon: 'warning',
                confirmButtonText: 'OK'
            });
            return;
        }

        const cart = JSON.parse(localStorage.getItem('cart')) || [];
        const existingProduct = cart.find(item => item.productID === product.ProductID);

        if (existingProduct) {
            existingProduct.quantity += quantity;
        } else {
            cart.push({
                productID: product.ProductID,
                productName: product.Name,
                productImage: product.image,
                productPrice: product.Price,
                quantity: quantity
            });
        }
        localStorage.setItem('cart', JSON.stringify(cart));

        Swal.fire({
            title: 'Produit ajouté au panier!',
            text: `Vous avez ajouté ${quantity} ${product.Name} au panier.`,
            icon: 'success',
            confirmButtonText: 'OK',
            timer: 3000,
        });
    };

    if (!product) return <div className="loading">Loading...</div>;

    return (
        <AnimationRevealPage>
                  <ScrollToTop />

            {role === 'supplier' ? <Light /> : <LightBuyer />}
            <div className="container mt-5">
            {role === "buyer" && (
  <div className="alert alert-danger">
    <p>Vous ne pouvez pas passer des commandes en tant que acheteur.</p>
  </div>
)}


                <div className="row">
                    <div className="col-md-6 mb-4">
                        <img src={`https://xn--cafnenero-d4a.com/storage/${product.image}`} alt={product.Name} className="img-fluid rounded mb-3" />
                    </div>
                    <div className="col-md-6">
                        <h2 className="mb-3" style={{ color: '#1e3d56', fontSize: '2.5rem' }}>{product.Name}</h2>
                        <p className="text-muted mb-4">{product.Description}</p>
                        <div className="mb-3">
                            Prix : <span className="h4 me-2">{product.Price} DH</span>
                        </div>
                       {product.StockQuantity === 0 && (
  <p className="mb-4" style={{ color: 'red' }}>En rupture de stock</p>
)}
                        <div className="mb-4">
                            <label htmlFor="quantity" className="form-label">Quantité:</label>
                            <input type="number" className="form-control" id="quantity" value={quantity} min="1" max={product.StockQuantity} onChange={(e) => setQuantity(Number(e.target.value))} style={{ width: '80px' }} />
                        </div>
                        <div className="d-flex gap-3">
                            <button
                                className="btn"
                                style={{ backgroundColor: '#1e3d56', color: 'white', width: '200px', fontSize: '16px', padding: '10px' }}
                                onClick={handleAddToCart}
                                disabled={!isActive} // Disable the button if no admin
                            >
                                <i className="bi bi-cart-plus"></i> Ajouter au panier
                            </button>

                            <button
                                className="btn"
                                style={{ backgroundColor: 'white', color: '#1e3d56', border: '1px solid #1e3d56', width: '200px', fontSize: '16px', padding: '10px' }}
                                onClick={() => navigate('/checkout')}
                                disabled={!isActive} // Disable the button if no admin
                            >
                                <i className="bi bi-credit-card"></i> Passer à la caisse
                            </button>
                        </div>

                    </div>
                </div>

                <h1 className="mt-5 text-center" style={{ fontSize: '22px', color: '#1e3d56' }}>
                    Produits similaires
                </h1><br />
               <div className="row">
    {relatedProducts.length > 0 ? (
        relatedProducts.slice(0, 4).map(relatedProduct => (
            <div key={relatedProduct.ProductID} className="col-md-3">
                <div className="card"><Link to={`/product-details/${relatedProduct.ProductID}`}>
    <img 
        src={`https://xn--cafnenero-d4a.com/storage/${relatedProduct.image}`} 
        className="card-img-top" 
        alt={relatedProduct.Name} 
        style={{ width: "100%", height: "200px", objectFit: "cover" }} 
    />
</Link>
<div className="card-body">
<h5 className="card-title text-truncate">{relatedProduct.Name}</h5>
                        <p className="card-text">{relatedProduct.Price} DH</p>
                    </div>
                </div>
            </div>
        ))
    ) : (
        <p>Aucun produit similaire trouv�.</p>
    )}
</div>
            </div>
            <Footer />
        </AnimationRevealPage>
    );
};

export default ProductDetails;
